
import request from '@/request'
const part_url = '/train/web/examination/';



/**
 * 查询考试列表
 *
 * @param {*} pageNow 当前页
 * @param {*} pageSize 页容
 * @param {*} examMode 考试模式
 * @param {*} type 考试类型
 * @returns
 */
function getExaminationList(data) {
  let url = part_url + "getExaminationList";
  return request.get(url, data)
}

/**
 * 开始考试
 * @param {*} examinationId 考试id
 * @param {*} testpaperId 试卷id
 * @param {*} type 考试模式 1 练习模式 2 考试模式
 * @returns
 */
function startExamination(data) {
  let url = part_url + "startExamination";
  return request.get(url, data)
}

/**
 * 记录答案
 *
 * @param {*} recordId 记录ID
 * @param {*} subjectId 题目ID
 * @param {*} answer 答案
 * @param {*} type 类型 examination 考试、practiceExam 模拟考试
 * @returns
 */
function answerProcess(data) {
  let url = part_url + "answerProcess";
  return request.get(url, data)
}


/**
 * 提交考试
 *
 * @param {*} recordId 记录ID
 * @returns
 */
function submitExamination(data) {
  let url = part_url + "submitExamination";
  return request.get(url, data)
}
/**
 * 标记考试题目
 *
 * @param {*} recordId 记录ID
 * @param {*} subjectId 记录ID
 * @param {*} extension 扩展信息
 * @returns
 */
function sign(data) {
  let url = part_url + "sign";
  return request.get(url, data)
}

/**
 * 获取考试记录列表
 *
 * @param {*} pageNow 当前页
 * @param {*} pageSize 页容
 * @param {*} 
 * @returns
 */
function getExamRecordList(data) {
  let url = part_url + "getExamRecordList";
  return request.get(url, data)
}


/**
 * 删除考试记录
 *
 * @param {*} recordId 记录ID
 * @returns
 */
function removeExamRecord(data) {
  let url = part_url + "removeExamRecord";
  return request.get(url, data)
}


/**
 * 查看考试记录详情
 *
 * @param {*} recordId 记录ID
 * @returns
 */
function getExamRecordDetail(data) {
  let url = part_url + "getExamRecordDetail";
  return request.get(url, data)
}
/**
 * 查看考试记录详情
 *
 * @param {*} recordId 记录ID
 * @returns
 */
function getExamRecordResult(data) {
  let url = part_url + "getExamRecordResult";
  return request.get(url, data)
}

/**
 * 查看考试详情
 *
 * @param {*} examinationId 考试ID
 * @returns
 */
 function getExaminationDetail(data) {
  let url = part_url + "getExaminationDetail";
  return request.get(url, data)
}

/**
 * 校验考试是否可以进行
 *
 * @param {*} examinationId 考试ID
 * @returns
 */
 function checkExamination(data) {
  let url = part_url + "checkExamination";
  return request.get(url, data)
}

function getScoreMessage(data) {
  let url = part_url + "getScoreMessage";
  return request.get(url, data)
}
/**
 * 查询考试日历
 * @param {*} data 
 * @returns 
 */

function getRemindExam(data) {
  let url = part_url + "getRemindExam";
  return request.get(url, data)
}


export default {
    getExaminationList,
    answerProcess,
    startExamination,
    submitExamination,
    sign,
    getExamRecordList,
    removeExamRecord,
    getExamRecordDetail,
    getExamRecordResult,
    getExaminationDetail,
    checkExamination,
    getScoreMessage,
    getRemindExam
}


// WEBPACK FOOTER //
// ./src/api/examination.js